module.exports = __webpack_public_path__ + "static/media/76298_1510519641231_5582148_n.56c5a3ae.jpg";